
export function formatDate(date, format = 'default') {
  if (!date) return '';
  
  let dateObj;
  
  if (date instanceof Date) {
    dateObj = date;
  } else if (typeof date === 'string' && !isNaN(Date.parse(date))) {
    dateObj = new Date(date);
  } else {
    return '';
  }
  
  // Check for invalid date
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  
  switch (format) {
    case 'short':
      return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    case 'medium':
      return dateObj.toLocaleDateString('en-US', options);
    case 'long':
      return dateObj.toLocaleDateString('en-US', {
        ...options,
        weekday: 'long'
      });
    case 'iso':
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    default:
      return dateObj.toLocaleDateString('en-US', options);
  }
}

export function formatDateRange(startDate, endDate) {
  if (!startDate) return '';
  
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : null;
  
  if (!end || start.toDateString() === end.toDateString()) {
    return formatDate(start, 'medium');
  }
  
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  
  if (startYear === endYear) {
    const startMonth = start.toLocaleDateString('en-US', { month: 'long' });
    const endMonth = end.toLocaleDateString('en-US', { month: 'long' });
    
    if (startMonth === endMonth) {
      return `${startMonth} ${start.getDate()}-${end.getDate()}, ${startYear}`;
    } else {
      return `${startMonth} ${start.getDate()} - ${endMonth} ${end.getDate()}, ${startYear}`;
    }
  } else {
    return `${formatDate(start, 'medium')} - ${formatDate(end, 'medium')}`;
  }
}
